/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow, FlexCol } from 'sarsaparilla';
import get from 'lodash/get';
import { CAMPSITE_PREFERENCES_DELIMITER } from '../../constants';

export default class PreferenceDetailItem extends React.Component {
    static defaultProps = {
        date: undefined,
        dateIndex: undefined,
        options: [],
        choice: '',
        disablePreferences: false,
    };

    static propTypes = {
        date: PropTypes.string,
        dateIndex: PropTypes.number,
        options: PropTypes.arrayOf(PropTypes.shape({})),
        handleOptionSelection: PropTypes.func,
        disablePreferences: PropTypes.bool,
        choice: PropTypes.string,
        disableSecondPreference: PropTypes.bool,
    };

    componentDidMount() {
        this.handleChange('', get(this.props, 'choice', ''));
    }

    getOptions() {
        const { options } = this.props;

        if (!options) {
            return [];
        }

        return [
            { value: '', label: 'No Preference' },
            ...options.map((option) => ({
                value: option.id,
                label: this.buildTextualCampsiteRepresentation(option),
            })),
        ];
    }

    getPreference(allPreferences, prefNum) {
        const delimitedValues = allPreferences.split(CAMPSITE_PREFERENCES_DELIMITER);
        return get(delimitedValues, prefNum, '');
    }

    handleChange(value, allPreferences = '', prefNum) {
        const delimitedValues = allPreferences.split(CAMPSITE_PREFERENCES_DELIMITER);
        delimitedValues[prefNum] = value;

        const date = this.props.date;
        this.props.handleOptionSelection(
            date,
            delimitedValues.join(CAMPSITE_PREFERENCES_DELIMITER)
        );
    }

    buildTextualCampsiteRepresentation(campsite) {
        if (campsite === undefined) {
            return 'No assignment';
        }
        let text = '';

        // don't show campsites at mile marker 0
        if (campsite.mileage) {
            text = `Mile-${campsite.mileage.toFixed(1)}`;
        }
        if (campsite.name) {
            text = `${text} ${campsite.name}`.trim();
        }
        if (campsite.max_group_size) {
            const groupPlural = campsite.max_group_size > 1 ? 'guests' : 'guest';
            text = `${text} - ${campsite.max_group_size} ${groupPlural} max`;
        }

        return text.trim();
    }

    render() {
        const { date, dateIndex } = this.props;
        if (!date || dateIndex === undefined || dateIndex === null) {
            return null;
        }

        return (
            <FlexRow className="per-preference-item">
                <FlexCol md={4} alignSelf="center">
                    <strong className="preferenceItemDate">Night of {date}</strong>
                </FlexCol>
                <FlexCol md={4}>
                    <select
                        id={`${dateIndex}-1`}
                        className="rec-select"
                        onChange={(e) => {
                            this.handleChange(e.target.value, this.props.choice, 0);
                        }}
                        value={this.getPreference(this.props.choice, 0)}
                        disabled={this.props.disablePreferences}
                    >
                        {this.getOptions()
                            .filter((op) => op)
                            .map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                    </select>
                </FlexCol>
                {!this.props.disableSecondPreference && (
                    <FlexCol md={4}>
                        <select
                            id={`${dateIndex}-2`}
                            className="rec-select"
                            onChange={(e) => {
                                this.handleChange(e.target.value, this.props.choice, 1);
                            }}
                            value={this.getPreference(this.props.choice, 1)}
                            disabled={this.props.disablePreferences}
                        >
                            {this.getOptions()
                                .filter((op) => op)
                                .map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                        </select>
                    </FlexCol>
                )}
            </FlexRow>
        );
    }
}
